import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { lotteryApi } from '../../api/lottery.js';
import { Spinner, ErrorBox } from '../../components/ui.js';
import { OrderDrawer, useDrawerClose } from '../../components/OrderDrawer.js';
import { OrderEditor } from './OrderDetailPage.js';

/**
 * 목록에서 주문번호(또는 '상세보기')를 클릭하면 목록은 그대로 두고 오른쪽에서
 * 슬라이드로 열리는 패널. 랜덤박스 주문 상세(randombox/OrderDetailModal.tsx)와
 * 같은 구조다 - 껍데기는 components/OrderDrawer, 안쪽은 OrderDetailPage 의
 * OrderEditor 를 그대로 재사용한다.
 *
 * App.tsx 가 "background location" 패턴으로 이 라우트를 목록 위에 겹쳐 띄운다 -
 * 그래서 뒤에 있는 목록은 그대로 살아있는 컴포넌트다(다시 조회하지 않는다).
 */
export function OrderDetailModal() {
  const { orderNo = '' } = useParams();
  const queryClient = useQueryClient();
  const close = useDrawerClose('/lottery/orders');

  const query = useQuery({
    queryKey: ['lottery', 'order', orderNo],
    queryFn: () => lotteryApi.order(orderNo),
    enabled: Boolean(orderNo),
  });

  return (
    <OrderDrawer onClose={close}>
      {query.isPending ? (
        <Spinner />
      ) : query.isError ? (
        <ErrorBox error={query.error} onRetry={() => void query.refetch()} />
      ) : (
        <OrderEditor key={orderNo} orderNo={orderNo} data={query.data} queryClient={queryClient} onClose={close} />
      )}
    </OrderDrawer>
  );
}
